import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'
import { Link } from 'react-router'

import Box from 'components/box'
import ValueLabel from 'components/value-label'
import EventListButton from 'components/event-list-button'
import { formatPriceDecimals } from 'utils/format'

import styles from './event-list-item.css'

const EventListItem = ({
  addNewDatesUrl,
  currencyCode,
  date,
  eventUrl,
  isVoucher,
  name,
  soldTickets,
  totalPartnerShare,
  venue,
  onCardClick,
  onLinkClick,
}) => (
  <div styleName="event-list-item">
    <Box interactive>
      <div  // eslint-disable-line jsx-a11y/no-static-element-interactions
        styleName="wrapper"
        onClick={onCardClick}
      >
        <Relayout gutter={false} valign="top">
          <RelayoutItem sm="12" lg="6">
            <div styleName="title">
              <ValueLabel
                label={<span>{date}<br />{venue}</span>}
                value={name}
              />
            </div>
          </RelayoutItem>
          <RelayoutItem sm="6" lg="3" styleName="meta">
            <div styleName="value-tickets">
              <ValueLabel align="center" label={isVoucher ? 'Vouchers sold' : 'Tickets sold'} value={soldTickets} />
            </div>
          </RelayoutItem>
          <RelayoutItem sm="6" lg="3" styleName="meta">
            <div styleName="value-total-partner-share">
              <ValueLabel
                align="center"
                label="Total revenue"
                value={formatPriceDecimals(totalPartnerShare, currencyCode)}
              />
            </div>
          </RelayoutItem>
          <RelayoutItem sm="12">
            <div styleName="actions">
              <Link styleName="action-view" to={eventUrl} onClick={onLinkClick}>
                <EventListButton label={isVoucher ? 'View Voucher' : 'View Event'} type="primary" />
              </Link>
              {addNewDatesUrl &&
                <a href={addNewDatesUrl} styleName="action-add" onClick={onLinkClick}>
                  <EventListButton label={!isVoucher? 'Add New Dates' : 'Add New Vouchers'} type="secondary" />
                </a>
              }
            </div>
          </RelayoutItem>
        </Relayout>
      </div>
    </Box>
  </div>
)

EventListItem.propTypes = {
  addNewDatesUrl: PropTypes.string,
  currencyCode: PropTypes.string,
  date: PropTypes.string,
  eventUrl: PropTypes.string,
  isVoucher: PropTypes.bool,
  onCardClick: PropTypes.func,
  onLinkClick: PropTypes.func,
  name: PropTypes.string,
  soldTickets: PropTypes.any,
  totalPartnerShare: PropTypes.string,
  venue: PropTypes.string,
}

export default CSSModules(EventListItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-list-item/event-list-item.js
 **/